import React, { useId } from "react";
import Icon from "../icons/Icon";
import { useDialogChrome } from "../../hooks/useDialogChrome";

function Modal({ title, onClose, children, footer, closeButton = false }) {
  const titleId = useId();
  const { dialogRef, handleKeyDown, handleOverlayPress } = useDialogChrome(onClose);

  return (
    <div className="overlay" onMouseDown={handleOverlayPress}>
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        ref={dialogRef}
        onKeyDown={handleKeyDown}
      >
        <div className="modal-head">
          <h2 className="modal-title" id={titleId}>
            {title}
          </h2>

          {closeButton && (
            <button className="dialog-close" type="button" aria-label="Fechar" onClick={onClose}>
              <Icon name="x" strokeWidth={2.5} />
            </button>
          )}
        </div>

        <div className="modal-body">{children}</div>

        <div className="modal-foot">
          {footer || (
            <button className="btn btn-secondary" type="button" onClick={onClose}>
              Fechar
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Modal;
